export default function productDirective() {
  return {
    template: require('./product.html'),
    scope: {
      vendorId: '=',
      product: '=',
      functionVendorId: '=',
      isVendorDialog: '<',
      isEdit: '<',
      deleteCallback: '&',
      tooltipAppendToSelector: '@',
    },
    controller: 'EMProductController',
    controllerAs: 'productVM',
    bindToController: true,
    replace: true,
  };
}
